<template>
  <div>
    <input
      type="file"
      id="certificate-file"
      ref="file"
      v-on:change="handleFileUpload()"
      style="display: none"
    />
    <button class="btn btn-secondary btn-size-medium mt-5 w-full" @click="$refs.file.click()">
      Select File
    </button>
    <p class="my-3">
      <small>{{ file.name }}</small>
    </p>
    <button
      class="btn btn-secondary btn-size-medium my-4 w-full includedIcon"
      @click="submitFile()"
    >
      <upload-icon />Upload Certificate
    </button>
    <vs-progress indeterminate color="primary" v-if="uploadingCTCertificate"></vs-progress>
  </div>
</template>

<script>
import store from '@/store/store';
import theApi from '@/mixins/theApi';
import { UploadIcon } from 'vue-feather-icons';

export default {
  components: {
    UploadIcon,
  },
  data() {
    return {
      file: '',
      certificateUploadUrl:
        $vjeConfig.VUE_APP_API_URL + 'student/workplace_safety/uploadCertificate',
      uploadingCTCertificate: false,
    };
  },
  methods: {
    async submitFile() {
      this.uploadingCTCertificate = true;
      let formData = new FormData();
      formData.append('file', this.file);

      theApi.methods
        .makeCall(false, 'workplace_safety/uploadCertificate', 'post', formData, false, true)
        .then(
          (data) => {
            this.file = '';
            if (data.status == 'OK') {
              store.commit('authStudent/preworkSetWSCert', data.url);

              const pw_data = {
                status_section: 'section_ws',
                section: 'workplace_safety_url',
                data: data.url,
                application_type: null,
              };
              store.dispatch('authStudent/completePreworkSection', pw_data);
            }
            this.uploadingCTCertificate = false;
          },
          () => {
            this.uploadingCTCertificate = false;
          },
        );
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
  },
};
</script>
